import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "goose_flight_token";

export const getDeviceToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
};
export const setDeviceToken = (t) => {
  try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
};
export const clearDeviceToken = () => setDeviceToken(null);

// Device-authenticated client for the Flight Control PWA. Sends the opaque
// device credential as a Bearer token; no cookies/producer session involved.
export const flightApi = axios.create({ baseURL: API });

flightApi.interceptors.request.use((config) => {
  config.headers["X-Goose-Origin"] = window.location.origin;
  const token = getDeviceToken();
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

flightApi.interceptors.response.use(
  (r) => r,
  (err) => {
    // A revoked/invalid device must re-enroll rather than silently retry.
    if (err.response?.status === 401) clearDeviceToken();
    return Promise.reject(err);
  },
);
